import * as ol from 'openlayers'
import BaseEnlightLineAspect from './BaseEnlightLineAspect'
import { translate } from '../translation/native_translate.js';

export default class LocationAspect extends BaseEnlightLineAspect {

  constructor(data) {
    super(data);
    this.set('area', data.dataFieldTable.area);
    this.set('maxCapacity', data.dataFieldTable.maxCapacity);
    this.set('currentVisitors', data.dataFieldTable.currentVisitors);
    this.set('densityCategory', data.dataFieldTable.densityCategory);
    this.set('name', data.name);
    this.set('timestamp', data.timestamp);
    this.set('showToolTip',data.showToolTip);
    this.setZIndex(3);
  }

  createStyle(resolution) {
    let color = "#a366ff";

    let stringState = this.get('state') === "active" ? 3 : 1;

    switch (stringState) {
      case 1:
        color = "#ff0000";
        break;
      case 2:
        color = "#ff9900";
        break;
      case -1:
      case 3:
      case 4:
      default:
        color = "#009933";
        break;
    }

    let width = 1;
    if (resolution > 17) {
      width = 5; //1/(resolution * 200); //view.getZoom() - 4 + (view.getZoom() - 17);
    }

    if (width < 3) {
      width = 3;
    }
    let densityCategory = this.get('densityCategory');
    let style = '';
    if (densityCategory === 0) {
      this.setBaseColor('#A9A9A9');

      style = new ol.style.Style({
        // fill: new ol.style.Fill({
        //   color: 'rgba(0, 0, 255, 0.1)'
        // }),
        stroke: new ol.style.Stroke({
          color: '#A9A9A9',
          width: width,
          lineCap: "square",
        }),
      });
    } else if (densityCategory === 1) {
      this.setBaseColor(color);
      style = new ol.style.Style({
        // fill: new ol.style.Fill({
        //   color: 'rgba(0, 0, 255, 0.1)'
        // }),
        stroke: new ol.style.Stroke({
          color: color,
          fill: color,
          width: width,
          lineCap: "square",
        }),
      });

    } else if (densityCategory === 2){
      this.setBaseColor('#ffff00');

      style = new ol.style.Style({
        // fill: new ol.style.Fill({
        //   color: 'rgba(0, 0, 255, 0.1)'
        // }),
        stroke: new ol.style.Stroke({
          color: '#ffff00',
          width: width,
          lineCap: "square",
        }),
      });
    } else if (densityCategory === 3){
      this.setBaseColor('#ff8000');
      style = new ol.style.Style({
        // fill: new ol.style.Fill({
        //   color: 'rgba(0, 0, 255, 0.1)'
        // }),
        stroke: new ol.style.Stroke({
          color: '#ff8000',
          width: width,
          lineCap: "square",
        }),
      });
    } else {
      this.setBaseColor('#ff0000');
      style = new ol.style.Style({
        // fill: new ol.style.Fill({
        //   color: 'rgba(0, 0, 255, 0.1)'
        // }),
        stroke: new ol.style.Stroke({
          color: '#ff0000',
          width: width,
          lineCap: "square",
        }),
      });
    }

    return [style];
  }

  createTooltip() {
    let showTl = this.get('showToolTip');
    if(showTl ==  false)
    {
      return;
    }
    let parent = this.get('parentId');
    let owner = 'undefined';

    let ts = 'N/A';
    if(typeof this.get('timestamp') !== 'undefined'){
      ts = new Date(this.get('timestamp') * 1000);
    }

    let cv = 'N/A';
    if(this.get('densityCategory') == 1){
      cv = 'Good'
    }
    else if(this.get('densityCategory') == 2){
      cv = 'Crowded'
    }
    else if(this.get('densityCategory') == 3){
      cv = 'Warning'
    }
    else {
      cv = 'Critical'
    }
    let tooltipInfo = "<div id='map-popup-tooltip' >"
    tooltipInfo += "<p class='pop-up-atribute' > name: " + this.get('name') + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > owner: " + owner + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > state: " + this.get('state') + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > timestamp: " + ts + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > density state: " + cv + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > current visitors: " + this.get('currentVisitors') + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > max capacity: " + this.get('maxCapacity') + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > area: " + this.get('area').toFixed(2) + "m²</p>";
    tooltipInfo += "</div>";
    return tooltipInfo;
  }

  rightClick(pixel, gps, rightClickBehaviour = 0) {
    var forwardBehave = true;
    switch (rightClickBehaviour) {
      case 0: //normal behaviour

        break;
      case 1: //Relation creation
        forwardBehave = false;

        break;
    }

    if (forwardBehave) {
      let boxConfig = {
        customData: this.getObject(),
        gpsData: gps,
        parentId: 'ContextMenu',
        id: 'ContextMenu', //specific id for context menu box
        component: 'ContextMenu',
        name: "Menu",
        left: (pixel[0] + 10),
        top: (pixel[1] + 10 + 49), // +49 to adjust for navigation bar
        actions: [
          { 'id': '_removeAction', 'name': 'Remove', '_function': () => { this.removeObject(); } }
        ],
      }
    }
  }

  removeObject() {
    window.Event.vue.$confirm('WARNING_MESSAGE', 'WARNING_MESSAGE_TITLE', {
      confirmButtonText: translate('YES'),
      cancelButtonText: translate('NO'),
      type: 'warning'
    }).then(() => {

      const categoryCar = window.Event.vue.$store.getters.getPreferredCategoryCar;

      var requestObject = {
        "childId": {
          "datatype": "string",
          "value": this.get('relationId'),
        },
        "cleanDatabase": {
          "datatype": "bool",
          "value": true,
        }
      };

      if (categoryCar === 'undefined') {
        window.Event.vue.$notify.error({
          title: "RELATION_OBJECT_FAILS_TO_REMOVE",
          message: "ERROR",
          duration: 0
        });
      } else {
        this.setLastAction('removeObject');
        const request = window.dssUtility.createDSSRequest(categoryCar, "cleanupChild", requestObject);
        window.socket.sendMessage(request, () => {
          window.Event.vue.$notify.success({
            title: "RELATION_OBJECT_REMOVED",
            message: "Success"
          });
        });
      }
    });
  }
}
